export const getPathFromUrl = (url) => url.split(/[?#]/)[0];
export const getExtensionFromPath = (path) => path.split('.').pop();
export const getFileTypeFromContentType = (contentType) =>
  contentType.split('/')[0];

export const getFileType = (url) => {
  const ext = getExtensionFromPath(getPathFromUrl(url)).toUpperCase();
  switch (ext) {
    case 'JPG':
    case 'JPEG':
    case 'GIF':
    case 'PNG':
    case 'SVG':
      return 'image';

    case 'MP4':
    case 'MOV':
    case 'M4V':
    case 'AVI':
      return 'video';

    case 'MP3':
    case 'M4A':
      return 'audio';

    case 'PDF':
    case 'DOC':
    case 'DOCX':
    case 'RTF':
      return 'file';

    default:
      return 'file';
  }
};
